import {styled} from "@mui/material/styles";

export const GroupItems = styled('ul')({
  padding: 0,
});
